import {ExcelTemplateAPI} from "../../api/api.js";
import {downloadFile} from "../../utils/files.js";

const SET_START_LOADING = 'excelTemplateEditReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'excelTemplateEditReducer/SET_STOP_LOADING'
const SET_EXCEL_TEMPLATE = 'excelTemplateEditReducer/SET_EXCEL_TEMPLATE'

const initialState = {
    loading: false,
    excelTemplate: []
}

export const excelTemplateEditReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_EXCEL_TEMPLATE:
            return {
                ...state,
                excelTemplate: {
                    ...action.excelTemplate,
                    file: action.excelTemplate.file ? {name: action.excelTemplate.file?.split('/')[1]} : null
                }
            }

        default:
            return state
    }
}


export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.excelTemplateEditReducer.loading

export const setExcelTemplate = (excelTemplate) => ({type: SET_EXCEL_TEMPLATE, excelTemplate})
export const selectExcelTemplate = (state) => state.excelTemplateEditReducer.excelTemplate


export const getExcelTemplate = (templateID) => async (dispatch) => {
    dispatch(startLoading())

    const response = await ExcelTemplateAPI.getExcelTemplate(templateID)

    await dispatch(setExcelTemplate(response.data))

    dispatch(stopLoading())
}

export const uploadExcelTemplate = (excelTemplateID, projectID, file) => async (dispatch) => {
    dispatch(startLoading())

    let data

    if (file) {
        data = new FormData()
        data.append('file', file.file)
        data.append('project', projectID)
    } else {
        data = {project: projectID, file: null}
    }

    await ExcelTemplateAPI.uploadExcelTemplate(excelTemplateID, data)

    dispatch(stopLoading())
}

export const downloadExcelTemplate = (templateID) => async (dispatch) => {
    dispatch(startLoading())

    await downloadFile(ExcelTemplateAPI.downloadExcelTemplate(templateID))

    dispatch(stopLoading())
}